import React, { createContext, useEffect, useRef, useState } from "react";
import {submitLogs} from "../../config/AWSGlobalLog";
import { useTheme } from "@material-ui/core";
import { useWebcastSocket } from '../../context/WebcastSocket.jsx';

const SocketContainerWithReg = createContext(null);

export { SocketContainerWithReg };

/** Parse authorization.fields (JSON string) into object for name, email, etc. */
function parseAuthorizationFields(authorization) {
    if (authorization == null) return null;
    const fields = authorization.fields;
    if (typeof fields === "string") {
        try {
            return JSON.parse(fields);
        } catch {
            return null;
        }
    }
    return typeof fields === "object" && fields !== null ? fields : null;
}

export default ({ children, socket_wc,onDemand, authorization,noRegID, name, email, userID, eventID }) => {

    const fields = parseAuthorizationFields(authorization);
    const [socketioMethods, setSocketioMethods] = useState({});
        const {socket} = useWebcastSocket();

    useEffect(() => {

        console.log('Whats in socket',socket_wc)
        if (socket_wc) {

            socket_wc.on('connect', () => {
                submitLogs(
                    JSON.stringify({
                        status: 'User connected with socket.io',
                        message: `Socket.io Connected, for user ${ authorization ? JSON.stringify({ ...authorization, fields }) : 'User data not found'}`
            
                    }) )
            });



            socket_wc.on('connect_error', (error) => {
                submitLogs(
                    JSON.stringify({
                        status: 'ERROR - connect_error',
                        message: 'SOCKET.IO connect_error',
                        error: error
                    }) )

                console.error('Socket.io connection error:', error);
            });

            socket_wc.on("disconnect", (reason) => {
                submitLogs(
                    JSON.stringify({
                        status: 'ERROR - disconnect',
                        message: 'SOCKET.IO disconnect',
                        error: reason
                    }) )
                console.log('Socket.io connection error Reason ---->>>>>>>:', reason);

            });

        }
        return () => {
            // socket.emit('leaveRoom', eventId, userId);
            try {
                // socket.disconnect();
              socket_wc.emit('leaveEvent', authorization?.eventid, authorization?.findId);  

                console.log("Disconneting from socket.io");

            } catch (error) {

                submitLogs(
                    JSON.stringify({
                        status: 'ERROR - Tab closed etc',
                        message: 'SOCKET.IO disconnecting',
                        error: error
                    }) )
                console.error('Error disconnecting socket:', error);
            }
        }

    }, [authorization]);


    useEffect(() => {
        // if (socket_wc.connected) {

                // if(Object.entries(authorization).length >0) {

                console.log('socket_wc', socket_wc)

                    if (socket_wc) {

                        try {
                            let userData = {
                                name: fields?.name,
                                email: fields?.email,
                                userID: authorization?.findId,
                                eventID: authorization?.eventid,
                                onDemand: onDemand
                            }
                            
                            console.log('userDataFromSocketContainerWithReg', userData, { authorization, fields })
    
                            socket_wc.on('reconnect', (attemptNumber) => {
                                console.log(`Reconnected after ${attemptNumber} attempts`);
    
                                submitLogs(
                                    JSON.stringify({
                                        status: 'RECONNECTING',
                                        message: `Attempt number ${attemptNumber}, for user ${ userData ? JSON.stringify(userData) : 'User data not found'}`
                            
                                    }) )
                                
                                //Add below line, if socket.recovered did not worked (on socket.io server)
                                // socket_wc.emit('join', userData);
                            });
    
                            console.log('ConnectedFromSocketContainerWithReg', userData)
                            socket_wc.emit('join',userData);
        
                        } catch (error) {
                            submitLogs(
                                JSON.stringify({
                                    status: 'ERROR',
                                    message: 'SOCKET.IO Joining | Reconnecting',
                                    error: error.message
                                }) )
                            console.log('Socket.io connection error:', error.message); 
                        }

                }

                // }


        // }

        return () => {
            // socket_wc.off('message')
            // socket.disconnect()

        }
    }, [socket_wc, authorization])




    useEffect(() => {
        if (!socket) return;

        const onUserKicked = (data) => {
            console.log('userKickedFromSocket', data);
            // Notify stats immediately so Live Users can drop this email
            if (socket_wc && data?.email && data?.eventId) {
                socket_wc.emit('leaveEventByEmail', {
                    email: data.email,
                    eventID: data.eventId,
                    eventId: data.eventId,
                });
            }
        };

        socket.on('userKicked', onUserKicked);
        return () => {
            socket.off('userKicked', onUserKicked);
        };
    }, [socket, socket_wc]);

    return (
        <SocketContainerWithReg.Provider value={socketioMethods}>
            {children}
        </SocketContainerWithReg.Provider>
    );
};
